"use strict"

import React, { useState } from "react"
import { Modal, Button } from "react-bootstrap"
import { FormattedMessage } from "react-intl"

import ReactSelectionElement from "../../../../shared_components/widgets/ReactSelectionElement"

export default function ModalAddMethod({ sample, show, onHide, onSubmit }) {
  const [selectedMethods, setSelectedMethods] = useState([])

  const headers = [
    {
      id: "samplemanagement.sample.id",
      desc: "Sample ID",
    },
    { id: "samplemanagement.methods", desc: "Select Method(s)", extra_text: "*" },
  ]

  const spMethods = Object.values(sample.sampling_point.methods).sort((a, b) => {
    const nameA = a.name.toLowerCase()
    const nameB = b.name.toLowerCase()
    if (nameA > nameB) return 1
    if (nameA < nameB) return -1
    return 0
  })

  return (
    <Modal
      size={"sm"}
      dialogClassName={"common-modal"}
      show={show}
      onHide={onHide}
      backdrop={"static"}
      className={"overflow-scroll"}
    >
      <Modal.Header closeButton>
        <FormattedMessage id={"samplemanagement.add.methods"} defaultMessage={"Add Methods"} />
      </Modal.Header>

      <Modal.Body style={{ width: "800px" }}>
        <table className={"table table-bordered table-sm tbl_lanzatable"}>
          <thead>
            <tr>
              {headers.map((header) => (
                <th className={"text-center"} key={header["id"]} style={{ minWidth: "60px" }}>
                  <FormattedMessage id={header["id"]} description={`${header["desc"]} Column Name`} />
                  {header["extra_text"] || ""}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={"text-center"}>
                {sample.sample_id} {sample.alias && `(${sample.alias})`}
              </td>
              <td style={{ minWidth: "200px", maxWidth: "400px" }}>
                <ReactSelectionElement
                  name={sample.id}
                  list={spMethods.filter((method) => !sample.sample_methods.includes(method.name))}
                  getOptionLabel={(label) => `${label.name}: ${label.description || "-"}`}
                  onValueChange={(_, opts) => setSelectedMethods(opts)}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>
          <FormattedMessage id={"general.cancelButton"} description={"Cancel Button"} />
        </Button>
        <Button
          variant={"primary"}
          type={"submit"}
          onClick={(event) => {
            event.preventDefault()
            onSubmit(onHide, selectedMethods)
          }}
          disabled={selectedMethods.length === 0}
        >
          <span className={"fa fa-plus text_white"} />
          &nbsp;&nbsp; <FormattedMessage id={"samplemanagement.add.methods"} defaultMessage={"Add Methods"} />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
